// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import '@/assets/css/reset.css'
import 'babel-polyfill'
import axios from 'axios'
import './common/uitil'
import DateVal from './common/date'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'

Vue.use(DateVal);
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$axios = axios
import '@/assets/js/index.js'  //引入index.js文件 token登录请求反应接口
// import '@/assets/js/index.js'  //引入index.js文件 token登录请求反应接口
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  const isLogin = window.localStorage.getItem('token')
  if (isLogin !=null) {
      next()
  } else {
    if ( to.path === '/login' || to.path ==='/register' || to.path ==='/forgetPass' || to.path ==='/index' || to.path ==='/list' || to.path ==='/detail'){ //这就是跳出循环的关键
        next()
    } else {
      next('/index')
    }
  } 
})

Vue.use(Vuex);

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js